import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import CustomerInvoices2PageUI from './CustomerInvoices2PageUI.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class CustomerInvoices2PageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: null,
      invoiceList: null,
      createMode: false,
      customerList: null,
      invoiceItemList: null,
      updateMode: false,
      invoiceItemUpdateMode: false,
      createInvoiceItemMode: false,
      selectedInvoice: null,
      onUploadMode: false,
      uploadInvoiceSubmitted: false,
      uploadInvoiceSuccessMsg: null,
      uploadInvoiceErrorList: [],
    }
  }

  render() {
    return (
      <CustomerInvoices2PageUI
        context={this.props.context}
        account={this.state.account}
        invoiceList={this.state.invoiceList}
        selectedInvoice={this.state.selectedInvoice}
        customerList={this.state.customerList}
        invoiceItemList={this.state.invoiceItemList}
        onRefreshClick={this.onRefreshClick}
        onDownloadClick={this.onDownloadClick}
        //
        createMode={this.state.createMode}
        onCreateClick={() => { this.setState({ createMode: true }) }}
        onCancelCreateInvoice={() => { this.setState({ createMode: false }) }}
        //
        createInvoiceItemMode={this.state.createInvoiceItemMode}
        onCreateInvoiceItemClick={this.onCreateInvoiceItemClick}
        onCancelCreateInvoiceItem={() => { this.setState({ createInvoiceItemMode: false }) }}
        //
        updateMode={this.state.updateMode}
        onUpdateClick={this.onUpdateClick}
        onCancelClick={() => { this.setState({ updateMode: false }) }}
        //
        invoiceItemUpdateMode={this.state.invoiceItemUpdateMode}
        onUpdateInvoiceItemClick={this.onUpdateInvoiceItemClick}
        onUpdateInvoiceItemCancelClick={() => { this.setState({ invoiceItemUpdateMode: false }) }}
        //upload Invoice
        onUploadMode={this.state.onUploadMode}
        onUploadInvoiceClick={this.onUploadInvoiceClick}
        onUploadInvoiceCancelClick={this.onUploadInvoiceCancelClick}
        onUploadInvoice={this.onUploadInvoice}
        //deletee uploaded invoice files
        onDeleteClick={this.onDeleteClick}
        onDeleteClickCallback={this.onDeleteClickCallback}
        deleteSubmitted={this.state.deleteSubmitted}
        //deletee invoice
        onDeleteInvoiceClick={this.onDeleteInvoiceClick}
        onDeleteInvoiceClickCallback={this.onDeleteInvoiceClickCallback}
        //deletee invoice Item
        onDeleteItemClick={this.onDeleteItemClick}
        onDeleteItemClickCallback={this.onDeleteItemClickCallback}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getInvoices(context)
    this.getCustomers(context)
  }

  onCreateInvoiceItemClick = (event) => {
    let customerInvoiceId = event.currentTarget.getAttribute('data-invoice-id');
    let selectedInvoice = this.state.invoiceList.filter(i => i.customerInvoiceId === customerInvoiceId)[0]
    this.setState({ createInvoiceItemMode: true, selectedInvoice: selectedInvoice });
  };

  onUpdateInvoiceItemClick = (event) => {
    let customerInvoiceId = event.currentTarget.getAttribute('data-invoice-id');
    let selectedInvoice = this.state.invoiceList.filter(i => i.customerInvoiceId === customerInvoiceId)[0]
    this.setState({ invoiceItemUpdateMode: true, selectedInvoice: selectedInvoice })
  };

  onUpdateClick = (event) => {
    let customerInvoiceId = event.currentTarget.getAttribute('data-invoice-id');
    let selectedInvoice = this.state.invoiceList.filter(i => i.customerInvoiceId === customerInvoiceId)[0]
    this.setState({ updateMode: true, selectedInvoice: selectedInvoice })
  };
  onUploadInvoiceClick = (event) => {
    let customerInvoiceId = event.currentTarget.getAttribute('data-invoice-id');
    let selectedInvoice = this.state.invoiceList.find(i => i.customerInvoiceId === customerInvoiceId);
    this.setState({ onUploadMode: true, selectedInvoice });
  };
  onUploadInvoiceCancelClick = () => {
    this.setState({ onUploadMode: false, uploadInvoiceErrorList: [], uploadInvoiceSuccessMsg: null });
  };


  onUploadInvoice = (fileId, fileName, fileType, fileSize) => {
    this.setState({ uploadTDSSubmitted: true })
    RestApiUtils.post(this.props.context,
      `/api/su/accounts/${this.state.account.accountId}/customerInvoices/${this.state.selectedInvoice.customerInvoiceId}/validation`,
      this.onUploadInvoiceCallback, {
      fileUpload: {
        fileId: fileId,
        fileName: fileName,
        fileType: fileType,
        fileSize: fileSize
      }
    }
    )
  }

  onUploadInvoiceCallback = (response) => {
    this.setState({ uploadInvoiceSubmitted: false })
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    if (errorList.length) {
      this.setState({
        uploadInvoiceErrorList: errorList
      })
      return
    }

    this.setState({
      uploadInvoiceSuccessMsg: response.success,
      uploadInvoiceErrorList: errorList,
    })

    this.onRefreshClick()

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          uploadInvoiceSuccessMsg: null
        })
      }, 2000)
    }
  }

  onDownloadClick = (event) => {
    let fileName = event.currentTarget.getAttribute('data-file-name')
    let customerInvoiceId = event.currentTarget.getAttribute('data-invoice-id');
    const bucketEnum = 'VENDOR_BILL_ATTACHMENTS';
    const folder = `${customerInvoiceId}`;
    console.log('Folder path:', folder);
    this.setState({ downloadSubmitted: true })
    RestApiUtils.get(this.props.context,
      `/api/su/accounts/${this.props.match.params.accountId}/bucketEnum/${bucketEnum}/folders/${folder}/files/${fileName}/fileDownloadSignedUrl`,
      this.onDownloadClickCallback, null, null
    )
  }

  onDownloadClickCallback = (response) => {
    this.setState({ downloadSubmitted: false, downloadErrorList: response.errorList })
    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onDeleteClick = (event) => {
    if (this.state.deleteSubmitted)
      return

    let fileName = event.currentTarget.getAttribute('data-file-name')
    let customerInvoiceId = event.currentTarget.getAttribute('data-invoice-id');
    this.setState({ deleteSubmitted: true })
    RestApiUtils.delete(this.props.context,
      `/api/su/accounts/${this.props.match.params.accountId}/customerInvoices/${customerInvoiceId}/files/${fileName}`,
      this.onDeleteClickCallback, null, null
    )
  }

  onDeleteClickCallback = response => {
    this.setState({ deleteSubmitted: false })

    if (response.errorList.length === 0) {
      this.props.onRefreshClick()
    }
  }
  onDeleteItemClick = (event) => {
    if (this.state.deleteSubmitted)
      return

    let productItemId = event.currentTarget.getAttribute('data-product-item')
    let customerInvoiceId = event.currentTarget.getAttribute('data-invoice-id');
    this.setState({ deleteSubmitted: true })
    RestApiUtils.delete(this.props.context,
      `/api/su/accounts/${this.props.match.params.accountId}/invoices/${customerInvoiceId}/invoiceItems/productItems/${productItemId}`,
      this.onDeleteClickCallback, null, null
    )
  }

  onDeleteItemClickCallback = response => {
    this.setState({ deleteSubmitted: false })

    if (response.errorList.length === 0) {
      this.props.onRefreshClick()
    }
  }

  onDeleteInvoiceClick = (event) => {
    if (this.state.deleteSubmitted)
      return

    let customerInvoiceId = event.currentTarget.getAttribute('data-invoice-id');
    this.setState({ deleteSubmitted: true })
    RestApiUtils.delete(this.props.context,
      `/api/su/accounts/${this.props.match.params.accountId}/customerInvoices/${customerInvoiceId}`,
      this.onDeleteClickCallback, null, null
    )
  }

  onDeleteInvoiceClickCallback = response => {
    this.setState({ deleteSubmitted: false })

    if (response.errorList.length === 0) {
      this.props.onRefreshClick()
    }
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  getInvoices(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/customerInvoices`,
      cacheKey: CacheKeys.CustomerInvoices(this.props.match.params.accountId),
      callback: this.getInvoicesCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }
  getInvoicesCallback = (response) => {
    this.setState({ invoiceList: response.invoiceList })
  }

  getCustomers(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/customers`,
      cacheKey: CacheKeys.Customers(this.props.match.accountId),
      callback: this.getCustomersCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getCustomersCallback = (response) => {
    let customerList = response.customerList.map((customer) => {
      return { key: customer.customerId, value: customer.customerName }
    })
    this.setState({
      customerList: customerList
    })
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.CustomerInvoices(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.Customers(this.props.match.params.accountId))
    this.setState({ invoiceList: null, customerList: null },
      this.getInvoices(context),
      this.getCustomers(context)
    )
  }
}

export default withRouter(CustomerInvoices2PageSF)



